/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import MaterialTable from 'material-table'
import Button from '@material-ui/core/Button';
import { minPermisos } from '../../../../constants/permits';
import { useStyles, tableIcons } from '../styles';

const TableType2 = (props) => {
  const {
    dataTable = [],
    onUpdate,
    onDelete,
    onCreate,
    onSelectRow,
    onNotification,
    minValue,
    columns,
    isEditHidden = false,
    pageSize = 10,
    hiddenDelete = false,
    showButton = false,
    isSelection = false,
    loading,
  } = props;
  const classes = useStyles();
  const [selected, setSelectedRow] = useState(null);
  let data = [];

  if (dataTable) {
    data = dataTable;
  }

  return (
    <div className={classes.root}>
      <div style={{ maxWidth: '100%' }}>
        <MaterialTable
          localization={{
            pagination: {
              labelDisplayedRows: '{from}-{to} of {count}',
            },
            toolbar: {
              nRowsSelected: '{0} row(s) selected',
            },
            header: {
              actions: !isEditHidden ? 'Acción' : null,
            },
            body: {
              emptyDataSourceMessage: ' No hay datos en la tabla',
              filterRow: {
                filterTooltip: 'Filter',
              },
            },
          }}
          //icons={tableIcons}
          isLoading={loading}
          title={
            showButton && minValue >= minPermisos.ACTUALIZAR ? (
              <NotificationMail onNotification={onNotification} />
            ) : 'Filtre y edite'
          }
          columns={columns}
          data={data}
          onRowClick={(evt, selectedRow) => setSelectedRow(selectedRow.tableData.id)}
          options={{
            pageSize,
            loadingType: 'linear',
            actionsColumnIndex: -1,
            exportButton: true,
            draggable: false,
            filtering: false,
            search: true,
            padding: 'dense',
            exportAllData: true,
            showTextRowsSelected: false,
            showSelectAllCheckbox: false,
            addRowPosition: 'first',
            exportFileName: 'Exportación Lucia Analitics',
            headerStyle: {
              backgroundColor: '#FFF',
              color: '#000',
              fontSize: 16,
            },
            rowStyle: (rowData) => ({
              backgroundColor:
                selected === rowData.tableData.id ? '#EEE' : '#FFF',
              fontSize: 14,
            }),
            selection: isSelection,
            selectionProps: (rowData) => ({
              color: rowData?.tableData?.estado == 1 ? 'primary' : 'secondary',
            }),
          }}
          onSelectionChange={(rowData, selectedRow) => onSelectRow(selectedRow)}
          actions={[
            () => ({
              icon: 'delete',
              tooltip: 'Eliminar',
              onClick: (event, rowData) => onDelete(rowData),
              hidden: !hiddenDelete && minValue >= minPermisos.ELIMINAR,
            }),
          ]}
          editable={{
            isEditHidden: () => !minValue >= minPermisos.ACTUALIZAR || isEditHidden === true,
            onRowAddCancelled: () => !minValue >= minPermisos.CREAR,
            onRowAdd: (newData) => new Promise((resolve, reject) => {
              onCreate(newData);
              setTimeout(() => {
                resolve();
              }, 1000);
            }),
            onRowUpdate: (newData, oldData) => new Promise((resolve, reject) => {
              onUpdate({
                newData,
              });
              setTimeout(() => {
                resolve();
              }, 2000);
            }),
          }}
        />
      </div>
    </div>
  );
};

export default TableType2;

const NotificationMail = ({ onNotification }) => (
  <div style={{ display: 'inline-block' }}>
    <Button
      style={{ margin: '0 10px', backgroundColor: '#434f69' }}
      variant="contained"
      color="primary"
      onClick={(event) => onNotification(event)}
    >
      Notificar Cambio
    </Button>
  </div>
);
